import React from 'react'
import { Box, Typography } from '@mui/material'
import { Control, FieldErrors } from 'react-hook-form'

import { Button } from '../../../../interaxDesignSystemComponents'
import { INTERAX_COLORS } from '../../../../constants/colors'
import { InviteUserRow, InviteUsersFormValues } from './InviteUserRow'

interface InviteUsersFormPanelProps {
  control: Control<InviteUsersFormValues>
  errors: FieldErrors<InviteUsersFormValues>
  serverError: string
  editingIndex: number | null
  isSubmitting: boolean
  actionDisabled: boolean
  onSave: () => void
  inputLabels: {
    name: string
    email: string
    namePlaceholder: string
    emailPlaceholder: string
  }
  buttonLabels: {
    add: string
    update: string
  }
}

export const InviteUsersFormPanel: React.FC<InviteUsersFormPanelProps> = ({
  control,
  errors,
  serverError,
  editingIndex,
  isSubmitting,
  actionDisabled,
  onSave,
  inputLabels,
  buttonLabels
}) => {
  const currentButtonLabel = editingIndex === null ? buttonLabels.add : buttonLabels.update

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px', flex: 1, minHeight: 0 }}>
      <InviteUserRow
        control={control}
        labels={inputLabels}
        errors={{
          name: errors.name?.message as string | undefined,
          email: errors.email?.message as string | undefined
        }}
        autoFocus
      />

      <Button variant="secondary" onClick={onSave} disabled={isSubmitting || actionDisabled}>
        {currentButtonLabel}
      </Button>

      {serverError && <Typography sx={{ color: INTERAX_COLORS.redError, fontSize: '14px' }}>{serverError}</Typography>}
    </Box>
  )
}
